import $ from "jquery";
import once from "@drupal/once";
import autosize from 'autosize';
import { initNavigation } from "./components/nav";
import {initPersonItemList} from "./components/person-item-list";

if (typeof jQuery === "undefined") {
  window.jQuery = $;
  window.$ = $;
}

autosize(document.querySelectorAll('form textarea.form-textarea'));

$(() => {
  initNavigation();
});

// match height
const matchHeightSelector = ".equal-height";
const matchHeight = once("processed", matchHeightSelector).shift();
if (matchHeight) {
  import("./components/matchheight").then(({ initMatchHeight }) => {
    initMatchHeight();
  });
}

// togglers
const togglerSelector = ".sh-trig, .show-more, .sh-trig-fade";
const toggler = once("processed", togglerSelector).shift();
if (toggler) {
  import("./components/togglers").then(({ initTogglers }) => {
    initTogglers();
  });
}

// tabs
const tabsSelector = ".tabs";
const tabs = once("processed", tabsSelector).shift();
if (tabs) {
  import("./components/tabs").then(({ initTabs }) => {
    initTabs();
  });
}

// lightbox
const popupSelector = ".modal-trigger, .glightbox";
const popups = once("processed", popupSelector).shift();
if (popups) {
  import("./components/popups").then(({ initPopups }) => {
    initPopups();
  });
}

// sliders
const sliderSelector = ".slider";
const sliders = once("processed", sliderSelector).shift();
if (sliders) {
  import("./components/sliders").then(({ initSliders }) => {
    initSliders();
  });
}

// form floating labels
const floatLabelSelector = ".float-label__input";
const floatLabels = once("processed", floatLabelSelector).shift();
if (floatLabels) {
  import("./components/float-labels").then(({ initFloatingLabels }) => {
    initFloatingLabels();
  });
}

// fixed footer
const fixedFooterSelector = ".fixed-footer";
const footer = once("processed", fixedFooterSelector).shift();
if (footer) {
  import("./components/fixed-footer").then(({ initFixedFooter }) => {
    initFixedFooter();
  });
}

// smooth scroll
const smoothScrollSelector = ".smooth-scroll";
const smoothScroll = once("processed", smoothScrollSelector).shift();
if (smoothScroll) {
  import("./components/smooth-scroll").then(({ initSmoothScroll }) => {
    initSmoothScroll();
  });
}

// video
const videosSelector = ".video-play";
const video = once("processed", videosSelector).shift();
if (video) {
  import("./components/video").then(({ initVideo }) => {
    initVideo();
  });
}

// reference-logo-list
const referenceLogoListSelector = ".component-reference-logo-list";
const referenceLogoList = once("processed", referenceLogoListSelector).shift();
if (referenceLogoList) {
  import("./components/reference-logo-list").then(({ initReferenceLogoList }) => {
    initReferenceLogoList();
  });
}

// person-item-list
const personItemListSelector = ".component-person-item-list";
const personItemList = once("processed", personItemListSelector).shift();
if (personItemList) {
  import("./components/person-item-list").then(({ initPersonItemList }) => {
    initPersonItemList();
  });
}

// steps list
const stepsSelector = ".step-item-list-head--to-anim";
const steps = once("processed", stepsSelector).shift();
if (steps) {
  import("./components/step-item-list").then(({ initStepList }) => {
    initStepList();
  });
}

// svg map with offices
const svgMapPopupsSelector = ".svg-map-popup-trigger";
const svgMapPopups = once("processed", svgMapPopupsSelector).shift();
if (svgMapPopups) {
  import("./components/svg-map-popups").then(({ initSvgMapPopups }) => {
    initSvgMapPopups();
  });
}

// slide form
const slideFormTriggerSelector = ".slide-form-trigger";
const slideFormTriggers = once("processed", slideFormTriggerSelector).shift();
if (slideFormTriggers) {
  import("./components/slide-form").then(({ initSlideForm }) => {
    initSlideForm();
  });
}

// copy to clipboard
const copyTriggerSelector = ".clipboard-copy";
const copyTriggers = once("processed", copyTriggerSelector).shift();
if (copyTriggers) {
  import("./components/clipboard-copy").then(({ initClipboard }) => {
    initClipboard();
  });
}

// image comparison
const imageComparisonSelector = ".image-comparison";
const imageComparisons = once("processed", imageComparisonSelector).shift();
if (imageComparisons) {
  import("./components/image-comparison").then(({ initImageComparison }) => {
    initImageComparison();
  });
}

// loop item list (partner list)
const loopItemListSelector = ".loop-item-list";
const loopItemLists = once("processed", loopItemListSelector).shift();
if (loopItemLists) {
  import("./components/loop-item-list").then(({ initLoopItemList }) => {
    initLoopItemList();
  });
}

// item lists show/hide
const shItemSelector = ".sh-item-trigger";
const shItems = once("processed", shItemSelector).shift();
if (shItemSelector) {
  import("./components/sh-item").then(({ initItemShowHide }) => {
    initItemShowHide();
  });
}

// sticky cta
const stickyCtaTrigSelector = ".sticky-cta-trigger";
const stickyCtaTriggers = once("processed", stickyCtaTrigSelector).shift();
if (stickyCtaTriggers) {
  import("./components/sticky-cta").then(({ initStickyCta }) => {
    initStickyCta();
  });
}

// accordion
const accordionSelector = ".accordion";
const accordions = once("processed", accordionSelector).shift();
if (accordions) {
  import("./components/accordion").then(({ initAccordions }) => {
    initAccordions();
  });
}

var $component = once("processed", ".component-certificate-item-list-slider").shift()
if ($component) {
  import("../../templates/component/certificate-item-list-slider/js/certificate-item-list-slider")
}
var $component = once("processed", ".js-lightbox, .js-lightbox-group").shift()
if ($component) {
  import("../../templates/component/picture/js/picture")
}
var $component = once("processed-styleguide", "body.styleguide").shift();
if ($component) {
  import("../../src/js/styleguide");
}
var $component = once('processed', 'body').shift()
if ($component && typeof ccnstL !== 'undefined') {
  import('../../templates/component/cookieconsent/js/cookieconsent')
}
